<!-- Start Page Title Area -->
<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">{{home}}</a></li>
                <li><a routerLink="/lessons">{{englishLesson}}</a></li>
                <li>{{course.name}}</li>
            </ul>
            <h2>{{courseDetail}}</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Courses Details Area -->
<section class="courses-details-area pt-100 pb-70">
    <div class="container">
        <div class="courses-details-header">
            <div class="row align-items-center">
                <div class="col-lg-8">
                    <div class="courses-title">
                        <h2>{{course.name}}</h2>
                    </div>

                    <div class="courses-meta">
                        <ul>
                            <li>
                                <i class='bx bx-calendar'></i>
                                <span
                                    *ngIf="course.createdAt">{{course.createdAt['seconds'] * 1000 | date:'MMM-dd-yyyy HH:mm:aa' }}</span>
                            </li>
                            <li *ngIf="course.quiz">
                                <a (click)="onShowQuiz()" class="btn" href="javascript:;">
                                    Take Quiz
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- <div class="col-lg-4">
                    <div class="courses-price">
                        <div class="courses-review">
                            <div class="review-stars">
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                            </div>
                            <span class="reviews-total d-inline-block">(2 reviews)</span>
                        </div>

                        <div class="price">Free</div>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8">
                <div class="courses-details-image text-center">
                    <!-- <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" [src]="videoUrl" allowfullscreen></iframe>
                    </div> -->
                    <div class="article-image">
                        <img [src]="imageUrl">
                    </div>
                </div>

                <div class="courses-details-desc">
                    <div [innerHTML]="htmlContent"></div>
                </div>
            </div>
            <div class="col-lg-4">
                <!-- <div class="courses-sidebar-information">
                    <ul>
                        <li *ngFor="let video of course.videos;let i = index" class="text-left" [attr.data-index]="i">
                            <a (click)="onChooseVideo(video)" href="javascript:;">{{i+1}} • {{video.titleEn}}</a>
                        </li>

                    </ul>
                </div> -->
                <aside class="widget-area">
                    <section class="widget widget_raque_posts_thumb">
                        <h3 class="widget-title">{{relateCourseText}}</h3>

                        <article class="item" *ngFor="let course of relatedCourses;">
                            <a href="javascript:;" class="thumb" (click)="onChooseCourse(course)">
                                <img class="fullimage cover" src="{{course.image.fileUrl}}" >
                            </a>
                            <div class="info">
                                <time datetime="2019-06-30">{{course.createdAt['seconds'] * 1000 | date:'MMM-dd-yyyy HH:mm:aa' }}</time>
                                <h4 class="title usmall"><a href="javascript:;" (click)="onChooseCourse(course)">{{course.name}}</a></h4>
                            </div>

                            <div class="clear"></div>
                        </article>

                    </section>
                </aside>
            </div>

        </div>
    </div>
</section>

<app-quiz-dialog *ngIf="course.quiz" [lessonId]="123" [resultScore]="resultScore" [isLeftVisible]="!showScoreResult" [show]="showQuizDialog" [showHistoryButton]="showHistoryButton" [questions]="course.quiz" [instruction]="course.instruction" [audioUrl]="course.audioUrl" [audio]="course.audio" (onDismissCallback)="onDismissDialog()" (onSubmitCallBack)="onSubmitQuiz()" (onRetryQuizCallback)="onRetryQuiz()"  (onShuffleQuizCallback)="onShuffleQuiz()"></app-quiz-dialog>